/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1SerievideoVideoidLangs200,
  GetApiV1SerievideoVideoidLangs401,
  GetApiV1SerievideoVideoidLangs404,
  GetApiV1SerievideoVideoidLangs500,
  GetApiV1SerievideoVideoidLangsPathParams,
  GetApiV1SerievideoVideoidLangsQueryParams,
  GetApiV1SerievideoVideoidLangsQueryResponse,
} from "../../types/serieVideoIdiomasController/GetApiV1SerievideoVideoidLangs.ts";
import { serieVideoLangViewModelPaginatedResponseSchema } from "../serieVideoLangViewModelPaginatedResponseSchema.ts";

export const getApiV1SerievideoVideoidLangsPathParamsSchema = z.object({
  videoId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1SerievideoVideoidLangsPathParams>;

export const getApiV1SerievideoVideoidLangsQueryParamsSchema = z.object({
  serieId: z.optional(z.coerce.number().int()),
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1SerievideoVideoidLangsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1SerievideoVideoidLangs200Schema = z.lazy(
  () => serieVideoLangViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1SerievideoVideoidLangs200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1SerievideoVideoidLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoVideoidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1SerievideoVideoidLangs404Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoVideoidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1SerievideoVideoidLangs500Schema =
  z.any() as unknown as ToZod<GetApiV1SerievideoVideoidLangs500>;

export const getApiV1SerievideoVideoidLangsQueryResponseSchema = z.lazy(
  () => getApiV1SerievideoVideoidLangs200Schema,
) as unknown as ToZod<GetApiV1SerievideoVideoidLangsQueryResponse>;
